import { render, staticRenderFns } from "./fees_setting.vue?vue&type=template&id=f62b04d4&"
import script from "./fees_setting.vue?vue&type=script&lang=js&"
export * from "./fees_setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports